export type KaapClusterRef = {
  id: string;
  name: string;
  /** The selected node groups that exist in this cluster. */
  nodeGroups: string[];
};

export type KaapClusterNodeGroupValue = {
  /** Every cluster belongs to the same `tier`. */
  clusters: KaapClusterRef[];
  tier: string;
  /** Every selected node group, whichever cluster it belongs to. */
  nodeGroups: string[];
};

export type KaapGitOpsConfigValue = {
  enabled: boolean;
  gitRepos: string[];
  rootPath: string;
  helmRepos: string[];
};

export type KaapTenantFormMode = 'create' | 'edit';

export interface KaapTenantFormUiOptions {
  mode?: KaapTenantFormMode;
  /** Lets the user pick several clusters of the same tier. Defaults to one. */
  allowMultiClusterSelection?: boolean;
  /** Carried from the legacy security-group field ui:options. The actual
   *  exclusion is hard-coded in ArmApiClient; kept here for parity. */
  excludeWellKnownGroups?: boolean;
  excludeType?: string;
}

export interface KaapTenantFormData {
  stage: string;
  tenantName: string;
  owner: string;
  securityObjectIds: string[];
  pimEnabled: boolean;
  application: string;
  slackChannel: string;
  clusterSelection: KaapClusterNodeGroupValue;
  namespaceQuota: string;
  cpuRequest: string;
  cpuLimit: string;
  memoryRequest: string;
  memoryLimit: string;
  /** Left undefined until resolved so the "auto-check when tier is external"
   *  logic can tell a user choice apart from the initial state. */
  cabInform?: boolean;
  // Edit-only carriers (prefilled by buildFormData, rendered read-only).
  tenantId?: string;
  tier?: string;
  ownerObjectId?: string;
  gitopsConfig?: KaapGitOpsConfigValue;
}

export const DEFAULT_CLUSTER_SELECTION: KaapClusterNodeGroupValue = {
  clusters: [],
  tier: '',
  nodeGroups: [],
};

export const DEFAULT_DATA: KaapTenantFormData = {
  stage: 'dev',
  tenantName: '',
  owner: '',
  securityObjectIds: [],
  pimEnabled: false,
  application: '',
  slackChannel: '',
  clusterSelection: DEFAULT_CLUSTER_SELECTION,
  namespaceQuota: '3',
  cpuRequest: '4000',
  cpuLimit: '4000',
  memoryRequest: '8192',
  memoryLimit: '8192',
};
